import { defineDocument } from '../../schema';
export const blogMeetQuinspireAFiveHighPyramidSchemeDocument = defineDocument({
    id: 'blog:meet-quinspire-a-five-high-pyramid-scheme',
    kind: 'blog',
    slug: 'meet-quinspire-a-five-high-pyramid-scheme',
    route: '/blog/meet-quinspire-a-five-high-pyramid-scheme',
    seo: {
        title: 'Meet Quinspire: A Five-High Pyramid Scheme',
        description: 'Think you can hang with this new word game?',
        imageAsset: 'coverQuinspire',
    },
    hero: {
        eyebrow: [
            {
                type: 'text',
                text: 'Airhead Blog',
            },
        ],
        title: [
            {
                type: 'text',
                text: 'Meet Quinspire: A Five-High Pyramid Scheme',
            },
        ],
        description: [
            {
                type: 'text',
                text: 'Think you can hang with this new word game?',
            },
        ],
        imageAsset: 'coverQuinspire',
        imageAlt: 'Quinspire cover art',
        showDescription: true,
        background: 'blurred-image',
    },
    meta: {
        author: 'Jay',
        publishedAt: new Date('2025-12-18T00:00:00.000Z'),
        tags: ['games'],
    },
    sections: [
        {
            id: 'article',
            blocks: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'What if classic hangman had party game energy? ',
                        },
                        {
                            type: 'link',
                            href: '/discover/games/quinspire',
                            children: [
                                {
                                    type: 'text',
                                    text: 'Quinspire',
                                },
                            ],
                        },
                        {
                            type: 'text',
                            text: ' is our answer to that question. We kept the core mechanic of guessing one letter at a time to make it feel familiar while also putting our own twist on it.',
                        },
                    ],
                },
            ],
            sections: [
                {
                    id: 'article__the-game-is-in-the-name',
                    title: [
                        {
                            type: 'text',
                            text: 'The Game is in the Name',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'What is a "Quinspire"? It comes from the Latin ',
                                },
                                {
                                    type: 'em',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'quinque',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' for the number five (think quintuplet or quintet) combined with ',
                                },
                                {
                                    type: 'em',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'spire',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ', a tower often in a pyramidal shape.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Five mysterious words are stacked into a pyramid, connected only by a theme. Players guess one letter at a time. Correct letters reveal in all words simultaneously. Wrong letters temporarily lock you out.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Race against the timer to earn points for correct letters and completed words. The player with the highest score at the end of the game wins, or challenge yourself to get a perfect score.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "The soundtrack deserves a mention, too. We had fun hiding wordplay in the track names, subtle nods to the game's core concepts that most players may not consciously notice. ",
                                },
                                {
                                    type: 'link',
                                    href: '/discover/music?game=quinspire',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Explore the music.',
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__party-of-one',
                    title: [
                        {
                            type: 'text',
                            text: 'Party of One',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Quinspire is the first game on our party game platform that can be played solo. After ',
                                },
                                {
                                    type: 'link',
                                    href: '/discover/games/second-opinions',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Second Opinions',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ", we wanted something that didn't require a lot of people or heavy strategizing. All you need to do is guess letters. Just you, the Quinspire, and the countdown timer.",
                                },
                            ],
                        },
                        {
                            type: 'quote',
                            content: [
                                {
                                    type: 'text',
                                    text: 'I kept testing the game longer than I needed to because I was having fun chasing a perfect score.',
                                },
                            ],
                            attribution: [
                                {
                                    type: 'text',
                                    text: 'Jay, Developer',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'This game is also a great way for new players to get acquainted with Airhead Games. A solo game can be played in 10 minutes or less, and gives you a feel for the platform without having to rope friends in quite yet.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__guess-again-and-again',
                    title: [
                        {
                            type: 'text',
                            text: 'Guess Again (and Again)',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "Unlimited guessing is a new platform mechanic we used in the creation of Quinspire and you can expect it in upcoming games, too. Limited guesses, like in classic hangman, didn't match the unpredictable nature of the words generated for each theme. With infinite possible letter combinations in a Quinspire, unlimited guessing felt like the most natural way to play.",
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "Although we don't limit the guesses, we do limit the time. The round timer scales dynamically based on the number of unique letters in each Quinspire. The lockout is long enough to sting but short enough to keep players focused on solving the puzzle. Even with a few mistakes, a perfect score is still achievable.",
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__it-s-the-climb',
                    title: [
                        {
                            type: 'text',
                            text: "It's the Climb",
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "One of the toughest design challenges was showing each player's progress on a shared screen without cluttering the experience or giving away the answers. We landed on lock icons, thumbs-up indicators, and dots to represent completed words above each avatar while correct guesses are highlighted in the Quinspire without being revealed to everyone. The whole room can get a sense for the progress of each player at a glance.",
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'In order to handle the rapid-fire nature of the game, we had to make some major upgrades to the event-processing pipeline of the platform. It was an unexpected challenge which ended up benefitting every game on the platform.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Also in this release:',
                                },
                            ],
                        },
                        {
                            type: 'list',
                            items: [
                                [
                                    {
                                        type: 'text',
                                        text: 'Fixed a bug in ',
                                    },
                                    {
                                        type: 'link',
                                        href: '/discover/games/meme-mash',
                                        children: [
                                            {
                                                type: 'text',
                                                text: 'Meme Mash',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'text',
                                        text: ' logic for grouping similar answers.',
                                    },
                                ],
                                [
                                    {
                                        type: 'text',
                                        text: 'Enhanced navigation of the login flow.',
                                    },
                                ],
                                [
                                    {
                                        type: 'text',
                                        text: 'Improved reliability for one-time passcode emails.',
                                    },
                                ],
                            ],
                        },
                    ],
                },
                {
                    id: 'article__down-to-hang',
                    title: [
                        {
                            type: 'text',
                            text: 'Down to hang?',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'link',
                                    href: '/library',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Play Quinspire now.',
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'article-actions',
            widgets: [
                {
                    type: 'relatedDocuments',
                    limit: 4,
                },
            ],
        },
    ],
});
//# sourceMappingURL=meet-quinspire-a-five-high-pyramid-scheme.js.map